/*
 * Responsive DMS - Listening for and reacting to events from NC iFrames.
 *
 * In MitBUPL, we have several iframes that come from the proxy/NetCompany.
 * These iFrames send postMessage's, to tell us when the iframe need to be
 * resized, the user has to be redirected etc.
 *
 * This file basically just listens for these messages, and reacts to them.
 * We only react to messages we understand - if NC introduces a new type
 * of message, this file needs to be updated.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window.postMessage
 */
document.addEventListener(
  "DOMContentLoaded",
  () => {
    var dmsLoadMessageHandler = function (iframe) {
      var dmsMessageHandler = function (event) {
        let eventData = event.data;

        // Sometimes, NC apparantly sends the data as a real object, and
        // other times, it's stringified JSON (wtf?).
        if (typeof eventData == "string") {
          try {
            eventData = JSON.parse(event.data);
          } catch (error) {
            eventData = {};
          }
        }

        switch (eventData.command) {
          // Resizing the iFrame, when we detect that the content has changed.
          // This avoids showing scrollbars when necessary.
          case "nccpResize":
          case "resize":
            var h = parseInt(eventData.height);
            iframe.style.height = h + "px";
            break;

          // Detecting if NC wants us to display a scrollbar.
          case "scrollbar":
            switch (eventData.toggle) {
              case "on":
                iframe.scrolling = "yes";
                iframe.style.overflow = "auto";
                break;
              case "off":
                iframe.scrolling = "no";
                iframe.style.overflow = "hidden";
                break;
            }
            break;

          // When the iFrame changes, we want to scroll back into view,
          // as we avoid iFrame scrollbars where possible.
          case "stepChange":
          case "scrollintoview":
            iframe.scrollIntoView();
            break;

          // Detect if NC wants to redirect the user.
          case "redirect":
          case "goto":
            var url = decodeURIComponent(eventData.url);

            // If we can see that we're on a /mit-bupl/ page, and the target
            // is the frontpage of BUPL, we'd rather send the user to
            // the frontpage of mitBUPL.
            if (
              url === "https://bupl.dk/" &&
              location.href.includes("/mit-bupl/")
            ) {
              url = "/mit-bupl";
            }

            location.href = url;
            break;
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", dmsMessageHandler);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", dmsMessageHandler);
      }
    };

    const iframes = document.querySelectorAll(
      ".js-dms-iframe[src]:not(.is-responsive-initialized)",
    );

    iframes.forEach(function (iframe) {
      iframe.classList.add("is-responsive-initialized");

      dmsLoadMessageHandler(iframe);
    });
  },
  { once: true },
);
